import React from 'react';
import { motion } from 'framer-motion';
import experienceData from '../data/experience';
import { StickerBriefcase } from './ui/stickers';
import { stampContainer, stampUp, viewportOnce } from '../lib/motion';

const accents = ['bg-mint', 'bg-bubble', 'bg-sky', 'bg-sun'];

const Experience = () => {
  return (
    <section id="experience" className="py-20 md:py-28 bg-cream dark:bg-card/40 border-t-[3px] border-b-[3px] border-ink dark:border-cream">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.4 }}
          className="text-center mb-16"
        >
          <p className="font-display font-bold text-ink/60 dark:text-cream/60 mb-2">The journey so far</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-ink dark:text-cream">
            Where I've{' '}
            <span className="inline-block rotate-1 bg-mint px-3 brutal-border brutal-shadow-sm">
              Worked
            </span>
          </h2>
        </motion.div>

        <motion.div
          className="relative"
          variants={stampContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <div className="absolute left-[22px] top-2 bottom-2 w-0.5 bg-ink/25 dark:bg-cream/25" aria-hidden="true" />

          {experienceData.map((job, index) => (
            <motion.div key={job.title + job.company} variants={stampUp} className="relative pl-16 pb-14 last:pb-0">
              <div className={`absolute left-0 top-0 flex h-11 w-11 items-center justify-center rounded-full ${accents[index % accents.length]} brutal-border-thin`}>
                <StickerBriefcase className="w-5 h-5 text-ink" />
              </div>

              <div className="flex flex-wrap items-center gap-3 mb-2">
                <h3 className="font-display text-xl font-extrabold text-ink dark:text-cream">{job.title}</h3>
                <span className="px-3 py-0.5 text-xs font-bold rounded-full bg-sun text-ink brutal-border-thin whitespace-nowrap">
                  {job.period}
                </span>
              </div>
              <p className="font-semibold text-ink/70 dark:text-cream/70 mb-4">{job.company}</p>

              <ul className="space-y-2.5">
                {job.responsibilities.map((responsibility, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm sm:text-base text-ink/80 dark:text-cream/80 leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-ink dark:bg-cream flex-shrink-0" />
                    <span>{responsibility}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
